import React from "react";

import { IgStatusCircle, IgTypography } from "@intelligems/ig-theme";
import { formatLastUpdatedText } from "@intelligems/ig-utils";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material";

import { WorkspaceEditorState } from "../../types";

/** Zone 3 left footer — the editor status strip (line count + save state). */
export interface StatusBarProps {
  editor: WorkspaceEditorState;
}

const formatLastSaved = (lastSavedTs: number | null): string =>
  formatLastUpdatedText(lastSavedTs, {
    fallback: "Never saved",
    noPrefix: true,
  });

export const StatusBar = ({ editor }: StatusBarProps) => {
  const theme = useTheme();
  const lineLabel = `${editor.lineCount} ${editor.lineCount === 1 ? "line" : "lines"}`;

  return (
    <Stack direction={"row"} justifyContent={"space-between"}>
      <Stack>
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{ px: 0.5, minHeight: 18 }}
        >
          <IgTypography variant="caption" color="text.tertiary">
            {lineLabel}
          </IgTypography>
          <IgTypography
            variant="caption"
            color={editor.isDirty ? "text.tertiary" : "text.secondary"}
          >
            {`Last Saved: ${formatLastSaved(editor.lastSavedTs)}`}
          </IgTypography>
        </Stack>
      </Stack>
      <Stack>
        {editor.isDirty && (
          <>
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <IgStatusCircle color={"warning"} />
              <IgTypography
                variant="caption"
                color={theme.palette.warning.main}
              >
                Unsaved changes
              </IgTypography>
            </Stack>
          </>
        )}
      </Stack>
    </Stack>
  );
};
